import { DocumentStatus } from "../../documents/Documents.types";
import { DocumentTypeUsageType } from "../../masterData/documentType/documentTypes/DocumentTypes.types";
import { SelectableItem } from "../../processingActivity/ProcessingActivity.types";
import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types";
import { DocumentVersionBestPracticeResultOverviewViewModel } from "@common/components/bestPracticeCheckDialog/BestPracticeCheckDialog.types.ts";

export interface SelectedLegalEntityDocument {
    legalEntityId: string | undefined;
    documentId: string;
    name: string;
    isGroupEntity?: boolean;
    documentTypeUsage?: DocumentTypeUsageType;
}

export class LegalEntityDocumentUpdateModel {
    documentId: string;
    fileName: string;
    name: string;
    documentTypeId?: string;
    addDocumentToSharings: Array<DocumentTypeUsageType>;
    ownerId: string | null;
    link: string | undefined;
    isLink: boolean;
    status: DocumentStatus | undefined;
    allGroupEntities: boolean;
    groupEntityAccessIds: Array<string>;

    constructor(allGroupEntities: boolean, documentId?: string, name?: string, link?: string, documentTypeId?: string, ownerId?: string | null) {
        this.documentId = documentId ?? "";
        this.fileName = "";
        this.name = name ?? "";
        this.documentTypeId = documentTypeId ?? undefined;
        this.addDocumentToSharings = [];
        this.ownerId = ownerId ?? null;
        this.link = link ?? "";
        this.isLink = link ? true : false;
        this.allGroupEntities = allGroupEntities;
        this.groupEntityAccessIds = [];
    }
}

export interface LegalEntityDocumentRow {
    legalEntityDocumentId: string;
    documentId: string;
    name: string;
    fileName: string;
    owner: BaseViewModel;
    documentType: BaseViewModel;
    link: string;
    version: number;
    dataId: string;
    status: DocumentStatus;
    allGroupEntities: boolean;
    groupEntities: Array<string>;
    created: Date;
    isTooLargeForAi: boolean;
    aiQualityAssuranceResult?: DocumentVersionBestPracticeResultOverviewViewModel;
}

export interface SelectableDocumentTypeItem extends SelectableItem {
    usages: Array<DocumentTypeUsageType>;
}
